<ng-container *ngIf="editMyBetState$ | async as editBetState">
    <div class="edit-bet-add-picks-container-desktop" *ngIf="editBetState.addPicksState.isVisible">
        <div class="edit-bet__selection-container__header">
            <div class="edit-bet__selection-container__header__control">
                <span
                    class="edit-bet__selection-container__header__count"
                    [ngClass]="{
                        'no-pick-selection': !hasPicks(),
                        'has-pick-selection': hasPicks(),
                    }">
                    {{ pickCount }}
                </span>
                <span>{{ getNewSelectionTitle(editBetState) }}</span>
            </div>
        </div>
        <div class="edit-bet__selection-container__picks">
            <ng-container [ngSwitch]="pickCount">
                <div class="edit-bet-add-picks-container-desktop_msg" *ngSwitchCase="0">
                    <span>{{ siteCore.betslip.editBet.addEditBetSelectionInfo }}</span>
                </div>
                <bs-edit-bet-add-pick-container *ngSwitchDefault></bs-edit-bet-add-pick-container>
            </ng-container>
        </div>
        <div class="edit-bet__selection-container__footer">
            <div>
                <button
                    ds-button
                    msThemedButton
                    kind="secondary"
                    variant="outline"
                    size="medium"
                    [themeSize]="buttonThemeSize"
                    (click)="cancelAddSelection(editBetState)">
                    {{ siteCore.betslip.editBet.cancel }}
                </button>
            </div>
            <div>
                <button
                    ds-button
                    msThemedButton
                    kind="secondary"
                    variant="filled"
                    size="medium"
                    [themeKind]="buttonThemeKind"
                    [themeSize]="buttonThemeSize"
                    [disabled]="!hasPicks()"
                    (click)="addToBet(editBetState)">
                    {{ siteCore.betslip.editBet.addToBet }}
                </button>
                <span class="edit-bet__selection-container__locked_closed_picks__count" *ngIf="lockedOrClosedPicksCount">
                    {{ lockedOrClosedPicksInfo }}
                </span>
            </div>
        </div>
    </div>
</ng-container>
